import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

// The trainer advertises a single rate with a system-defined unit (AC-7). Maps the
// saved unit to its display message id (e.g. "$80 / session").
const UNIT_LABEL_IDS = {
  hour: 'ListingPage.fixedPricing.hour',
  session: 'ListingPage.fixedPricing.session',
  month: 'ListingPage.fixedPricing.month',
};

/**
 * Renders the trainer's single advertised rate as a pill (e.g. "$80 / session").
 *
 * This is informational only — there is no checkout attached (AC-4). The block is
 * hidden when no rate is set (AC-3). The amount is formatted in the marketplace
 * currency (AC-5).
 *
 * @param {Object} props
 * @param {Object} props.publicData listing public data holding the fixed price (sub-units) and unit
 * @param {string} props.marketplaceCurrency ISO currency code, e.g. "USD"
 * @param {Object} props.intl react-intl instance
 * @returns {JSX.Element|null}
 */
const SectionFixedPricingMaybe = props => {
  const { publicData, marketplaceCurrency, intl } = props;

  if (!publicData || !marketplaceCurrency) {
    return null;
  }

  const subUnits = publicData.fixedPrice;
  const labelId = UNIT_LABEL_IDS[publicData.fixedPriceUnit];

  if (!(typeof subUnits === 'number' && subUnits > 0) || !labelId) {
    return null;
  }

  const formattedPrice = formatMoney(intl, new Money(subUnits, marketplaceCurrency));

  return (
    <p className={css.fixedPrice}>
      <FormattedMessage
        id={labelId}
        values={{
          price: <span className={css.priceAmount}>{formattedPrice}</span>,
          unit: chunks => <span className={css.priceUnit}>{chunks}</span>,
        }}
      />
    </p>
  );
};

export default SectionFixedPricingMaybe;
